import React from 'react';
import { Row } from 'antd';
import { Background } from '@/components/ui/Background';

interface BackgroundPageProps {
	children: JSX.Element;
}

export function BackgroundPage({ children }: Readonly<BackgroundPageProps>) {
	return (
		<>
			<Background />
			<Row justify="center" align="middle" style={{ width: '100vw', height: '100vh' }}>
				{children}
			</Row>
		</>
	);
}
